// utils/getProfileImage.js
import http from "@/services/http"; // ajuste o nome/arquivo conforme o seu projeto

// fallback carregado UMA vez só (fora da função)
const FALLBACK_IMAGE = require("@/assets/images/profile_default_image.png");

/**
 * Retorna:
 * - string: ObjectURL do blob (quando achou a imagem)
 * - FALLBACK_IMAGE: quando não tem imageName ou erro/nao encontrado
 */
export async function getProfileImage(imageName) {
  if (!imageName) return FALLBACK_IMAGE;

  try {
    const response = await http.get(
      `/api/avatar/users/search-image/${encodeURIComponent(imageName)}`,
      { responseType: "blob" },
    );

    // axios só cai no catch se status >= 400 (por padrão),
    // então se chegou aqui normalmente é 2xx.
    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error("Erro ao buscar a imagem:", error);
    return FALLBACK_IMAGE;
  }
}
